import { gql } from '@apollo/client'

export const CommunityDetailsFragment = gql`
	fragment CommunityDetailsFragment on Community {
		id
		title
		lat
		lon
		parentRestaurantMinOrderValueInCents
		parentRestaurantDeliveryFeeDefaultInCents
		parentRestaurantActive
		parentRestaurantNSubOrdersPerOrder
		parentRestaurantClosingMinutesBeforeDelivery
	}
`

export const RestaurantSlotDetailsFragment = gql`
	fragment RestaurantSlotDetailsFragment on RestaurantSlot {
		id
		day
		hour
		minute
	}
`

export const DeliverySlotDetailsFragment = gql`
	fragment DeliverySlotDetailsFragment on DeliverySlot {
		id
		deliveryTime
		closesAt
		bookingInfo {
			nTotalSeats
			nAvailableSeats
			nBookedSeats
			communityId
			nAuthorizedSeats
			isPaid
			orderStatus
			isJoinable
		}
	}
`

export const CategoryDetailsFragment = gql`
	fragment CategoryDetailsFragment on Category {
		id
		name
		description
		menuVersion
		status
		products {
			id
			name
			description
			categoryId
			priceInCents
			priceLabel
			status
			isDisabled
			variants {
				id
				name
				priceInCents
				priceLabel
				status
				optionGroups {
					id
					name
					isTypeMulti
					isRequired
					minChoices
					maxChoices
					status
					affectedProducts
					options {
						id
						name
						minAmount
						maxAmount
						priceInCents
						priceLabel
						status
						affectedProducts
						isDisabled
					}
				}
			}
		}
	}
`

export const OptionGroupDetailsFragment = gql`
	fragment OptionGroupDetailsFragment on OptionGroup {
		id
		name
		isTypeMulti
		isRequired
		minChoices
		maxChoices
		status
		affectedProducts
		options {
			id
			name
			minAmount
			maxAmount
			priceInCents
			priceLabel
			status
			affectedProducts
			isDisabled
		}
	}
`

export const CompanyDetailsFragment = gql`
	fragment CompanyDetailsFragment on Company {
		id
		name
		legalForm
		managingDirector
		street
		houseNumber
		zipCode
		city
		email
		phone
		website
		tradeRegisterNumber
		ustId
		taxId
		stripeAccountIdProd
		stripeAccountIdTest
		paymentMethod
	}
`

export const RestaurantInfoFragment = gql`
	fragment RestaurantInfoFragment on Restaurant {
		id
		title
		lat
		lon
		stripeAccountId
		phone
		email
		isUbimeal
		isActive
		visibility
		zipCode
		city
		street
		houseNumber
		menuVersion
		paymentMethod
		foodPayment
		serviceFeeInCents
		vacation
		company {
			...CompanyDetailsFragment
		}
		communities {
			...CommunityDetailsFragment
		}
		slots {
			...RestaurantSlotDetailsFragment
		}
		deliverySlots {
			...DeliverySlotDetailsFragment
		}
		menuHistory {
			version
			state
			date
			preview
			sourcePdf
		}
		sourceMenus {
			name
			date
			hasPdf
			hasJson
			menuVersion
		}
		slug
		kioskHeartbeats {
			deviceId
			kioskVersion
			webappVersion
			lastSeenAt
			hours {
				hour
				count
			}
		}
		onboardingLog {
			step
			at
			by
		}
		categories {
			...CategoryDetailsFragment
		}
	}
	${CompanyDetailsFragment}
	${CommunityDetailsFragment}
	${RestaurantSlotDetailsFragment}
	${DeliverySlotDetailsFragment}
	${CategoryDetailsFragment}
`

export const UserInfoFragment = gql`
	fragment UserInfoFragment on User {
		id
		email
		adminRestaurants {
			...RestaurantInfoFragment
		}
		isRestaurantAdmin
		isRoot
	}
	${RestaurantInfoFragment}
`

export default null
